<script lang="ts">
	import { getTenant } from "../getTenant.js";

	export let cookies: string;

	const tenant = getTenant();

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html `<script type="text/javascript" charset="UTF-8" data-cs-lang="${tenant.locale}" src="//cdn.cookie-script.com/s/${cookies}.js"></script>`}
